var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 7.975c-2.454-.118-4.16.756-5.118 2.625-1.435 2.801-.248 7.386 4.543 7.386 4.79 0 4.93-4.63 4.93-5.115V7.448c1.024.65 1.888 1.04 2.591 1.172.703.132 1.15.191 1.341.176V6.098c-.65-.078-1.213-.228-1.687-.448-.712-.331-2.123-1.25-2.123-2.595v-1.04H10.41c-.009 6.59-.009 10.208 0 10.857.013.972-.741 2.333-2.271 2.333-1.53 0-2.284-1.36-2.284-2.236 0-.537.184-1.315.946-1.891.452-.342 1.08-.478 2.097-.478V7.975Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
};
export default SvgTiktok;